import cn from 'classnames';
import React, { useEffect } from 'react';
import { usePathname, useRouter } from '@framework/next/navigation';
import { useTransactionTypeGroupsContext } from '../../../contexts/TransactionTypeGroupsContext';
import { useRestrictedListingContext } from '../../../contexts/RestrictedListingContext';
import { ITransactionTypeGroupItem } from '../../../domain/vo/TransactionTypeGroupItem';
import replaceUrlTail from '@framework/data-helpers/url/replaceUrlTail';
import { CountLabel } from '@dealroadshow/uikit-badge/CountLabel';
import tabsStyles from '@dealroadshow/uikit-styles/tabs.module.scss';
import spaceStyle from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import styles from './transactionTypeTabs.module.scss';

interface IProps {
  searchString: string,
  disabled?: boolean,
}

const TransactionTypeTabs = ({ searchString, disabled }: IProps) => {
  const router = useRouter();
  const pathname = usePathname();
  const {
    collection,
    activeGroup,
    setActiveGroup,
  } = useTransactionTypeGroupsContext();

  const {
    getCounts,
    allCounts,
  } = useRestrictedListingContext();

  useEffect(() => {
    getCounts(searchString);
  }, [searchString]);

  const handleChangeTab = (group: ITransactionTypeGroupItem) => {
    if (group.id !== activeGroup!.id) {
      router.replace(replaceUrlTail(
        pathname,
        activeGroup!.name?.toLowerCase(),
        group.name?.toLowerCase(),
      ));
      setActiveGroup(group);
    }
  };

  const renderTab = (group: ITransactionTypeGroupItem) => (
    <a
      onClick={ () => !disabled && handleChangeTab(group) }
      className={ cn(tabsStyles.tab, {
        [tabsStyles.isTabActive]: activeGroup!.id === group.id,
        [tabsStyles.isTabDisabled]: disabled,
      }) }
      key={ group.id }
      data-test={ group.name }
    >
      <span>{ group.name }</span>
      <CountLabel
        totalCount={ (allCounts as Record<string, { count?: number }>)[group.id]?.count || 0 }
        backgroundColor="#c0c0c0"
        maxTotalCount={ 999 }
        canShowCount
        className={ styles.countLabel }
        showCountWithZeroVolume
      />
    </a>
  );

  return (
    <ul className={ cn(spaceStyle.pln, styles.transactionTypeGroups) }>
      { collection.map(renderTab) }
    </ul>
  );
};

export default TransactionTypeTabs;
